document.addEventListener('DOMContentLoaded', function() {
  const filterDropDown = document.querySelector('.filter-drop-down');
  const filterButtons = document.querySelectorAll('.filter-wrap > ul li a');
  const wrapper = document.querySelector('.filters .wrapper');
  
  if (!filterDropDown || !wrapper) return;
  
  const trigger = filterDropDown.querySelector('span');
  const dropdownMenu = filterDropDown.querySelector('ul');
  const sortByText = filterDropDown.querySelector('.sort-by-text');
  const dropdownItems = filterDropDown.querySelectorAll('ul li a');
  
  // Wait for images to load, then apply matchHeight
  function applyMatchHeightAfterImagesLoad() {
    // Check if jQuery and matchHeight are available
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.matchHeight === 'undefined') {
      return;
    }
    
    // Get all items
    const allItems = document.querySelectorAll('.filters .wrapper .item');
    
    if (allItems.length === 0) {
      return;
    }
    
    // Get all images in items
    const images = [];
    allItems.forEach(function(item) {
      const img = item.querySelector('.img-wrap img');
      if (img) {
        images.push(img);
      }
    });
    
    // Function to actually apply matchHeight
    const actuallyApplyMatchHeight = function() {
      const $ = jQuery;
      
      // Apply matchHeight to img-wrap elements
      const imgWraps = Array.from(allItems).map(function(item) {
        return item.querySelector('.img-wrap');
      }).filter(function(el) {
        return el !== null;
      });
      
      if (imgWraps.length > 1) {
        // Remove previous matchHeight if any
        $(imgWraps).matchHeight('remove');
        // Apply matchHeight
        $(imgWraps).matchHeight({
          byRow: true
        });
      }
      
      // Apply matchHeight to text-block elements
      const textBlocks = Array.from(allItems).map(function(item) {
        return item.querySelector('.text-block');
      }).filter(function(el) {
        return el !== null;
      });
      
      if (textBlocks.length > 1) {
        // Remove previous matchHeight if any
        $(textBlocks).matchHeight('remove');
        // Apply matchHeight
        $(textBlocks).matchHeight({
          byRow: true
        });
      }
    };
    
    // If no images, apply matchHeight immediately
    if (images.length === 0) {
      actuallyApplyMatchHeight();
      return;
    }
    
    // Check if images are already loaded
    let loadedCount = 0;
    const totalImages = images.length;
    let allLoaded = true;
    let matchHeightApplied = false;
    let fallbackTimeout = null;
    
    // Function to check and apply matchHeight
    const checkAndApply = function() {
      if (!matchHeightApplied && loadedCount >= totalImages) {
        matchHeightApplied = true;
        if (fallbackTimeout) {
          clearTimeout(fallbackTimeout);
          fallbackTimeout = null;
        }
        // Small delay to ensure layout is updated after image loads
        setTimeout(actuallyApplyMatchHeight, 100);
      }
    };
    
    // Function to re-apply matchHeight (for images that load later)
    const reapplyMatchHeight = function() {
      setTimeout(actuallyApplyMatchHeight, 100);
    };
    
    images.forEach(function(img) {
      // Check if image is already loaded (complete or has naturalWidth)
      if (img.complete && img.naturalWidth > 0) {
        loadedCount++;
      } else {
        allLoaded = false;
        // Add load event listener
        const onLoad = function() {
          loadedCount++;
          img.removeEventListener('load', onLoad);
          img.removeEventListener('error', onLoad);
          checkAndApply();
          // Also re-apply when individual images load (for better UX)
          reapplyMatchHeight();
        };
        
        img.addEventListener('load', onLoad);
        img.addEventListener('error', onLoad); // Also handle errors
      }
    });
    
    // If all images were already loaded, apply matchHeight immediately
    if (allLoaded && loadedCount === totalImages) {
      setTimeout(actuallyApplyMatchHeight, 100);
      matchHeightApplied = true;
    } else {
      checkAndApply();
    }
    
    // Fallback: apply matchHeight after a maximum wait time (in case some images fail to load or are very slow)
    fallbackTimeout = setTimeout(function() {
      if (!matchHeightApplied) {
        matchHeightApplied = true;
        actuallyApplyMatchHeight();
      }
    }, 3000);
  }
  
  // Alias for backward compatibility
  function applyMatchHeight() {
    applyMatchHeightAfterImagesLoad();
  }
  
  // Expose matchHeight function globally so other scripts (e.g. pagination)
  // can trigger a recalculation after the grid content changes.
  if (typeof window !== 'undefined') {
    window.centrioFiltersApplyMatchHeight = applyMatchHeightAfterImagesLoad;
  }
  
  // Toggle dropdown on click
  trigger.addEventListener('click', function(e) {
    e.stopPropagation();
    filterDropDown.classList.toggle('active');
  });
  
  // Handle dropdown item selection (sorting)
  dropdownItems.forEach(function(item) {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Get the selected text
      const selectedText = this.textContent.trim();
      
      // Update the sort-by-text
      sortByText.textContent = selectedText.toLowerCase();
      
      // Remove active class from all items
      dropdownItems.forEach(function(link) {
        link.parentElement.classList.remove('selected');
      });
      
      // Add active class to selected item
      this.parentElement.classList.add('selected');
      
      // Close the dropdown
      filterDropDown.classList.remove('active');
      
      // Sort the items
      sortItems(selectedText.toLowerCase());
      
      // Apply matchHeight after sorting
      setTimeout(function() {
        applyMatchHeight();
      }, 100);
    });
  });
  
  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!filterDropDown.contains(e.target)) {
      filterDropDown.classList.remove('active');
    }
  });
  
  // Category Filter Buttons - Active/Inactive functionality
  filterButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Remove active class from all filter buttons
      filterButtons.forEach(function(btn) {
        btn.classList.remove('active');
      });
      
      // Add active class to clicked button
      this.classList.add('active');
    });
  });
  
  // Set initial active filter (View All)
  if (filterButtons.length > 0) {
    filterButtons[0].classList.add('active');
  }
  
  // Sort items by date
  function sortItems(sortOrder) {
    const items = document.querySelectorAll('.filters .wrapper .item');
    const itemsArray = Array.from(items);
    
    itemsArray.sort(function(a, b) {
      const dateA = a.getAttribute('data-date');
      const dateB = b.getAttribute('data-date');
      
      if (!dateA || !dateB) return 0;
      
      // Convert DD.MM.YYYY to comparable format
      const partsA = dateA.split('.');
      const partsB = dateB.split('.');
      const timestampA = new Date(partsA[2], partsA[1] - 1, partsA[0]).getTime();
      const timestampB = new Date(partsB[2], partsB[1] - 1, partsB[0]).getTime();
      
      if (sortOrder === 'newest first') {
        return timestampB - timestampA; // Descending
      } else {
        return timestampA - timestampB; // Ascending
      }
    });
    
    // Re-append items in sorted order
    itemsArray.forEach(function(item) {
      wrapper.appendChild(item);
    });
  }
  
  // Apply matchHeight on initial load
  setTimeout(function() {
    applyMatchHeight();
  }, 100);
  
  // Apply matchHeight on window resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      applyMatchHeight();
    }, 250);
  });
});

